/**
 * Anker-Hilfen für die PDP-Tabs, ohne DOM-Zugriff. Eigenes Modul, weil tabs.ts und tabDeepLink.ts
 * beide darauf zugreifen und sich sonst gegenseitig importieren würden.
 */

/** "#Kundeninformationen" → "kundeninformationen"; leerer oder kaputt kodierter Hash → null. */
export function normalizeTabHash(hash: string): string | null {
    let value = hash.startsWith('#') ? hash.substring(1) : hash;

    try {
        value = decodeURIComponent(value);
    } catch {
        return null;
    }

    value = value.trim().toLowerCase();
    return value.length > 0 ? value : null;
}
